

import React, { createContext, useState, useEffect, useContext } from 'react'; // Added useContext
import axios from 'axios';
import axiosInstance from '../utils/axiosInstance';

// Create AuthContext
export const AuthContext = createContext();

// Helper hook to use the context
export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false); // You had this, good for spinners
  const [isChecked, setChecked] = useState(false); // This is crucial

  useEffect(() => {
    const checkAuthStatus = async () => {
      const token = localStorage.getItem('token');
     console.log("token", token)
      if (!token) {
        setChecked(true);
        return;
      }

      try {
        const res = await axiosInstance.get('/users/verify');
        console.log("resp",res)
        setIsAuthenticated(true);
        setIsAdmin(res.data.is_admin);
        setUsername(res.data.username);
        localStorage.setItem('username', res.data.username);
        localStorage.setItem('is_admin', JSON.stringify(res.data.is_admin));

      } catch (err) {
        console.error("Auth check failed, logging out:", err.message);
        logout(); 
      } finally {
        setChecked(true);
      }
    };

    checkAuthStatus();
  }, []); 
  const login = (data) => {
    const { token, username, is_admin } = data;

    // 1. Set localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('username', username);
    localStorage.setItem('is_admin', JSON.stringify(is_admin));
    setIsAuthenticated(true);
    setIsAdmin(is_admin);
    setUsername(username);
  };

  // --- UPDATED Logout function ---
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem("is_admin"); 
    localStorage.removeItem('username');
    setIsAuthenticated(false);
    setIsAdmin(false);
    setUsername('');
  };

  // Your existing loading handler
  const loadingHandle = (isLoad) => {
    setLoading(isLoad);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isAdmin,
        username,
        loading,
        isChecked, // Pass this to consumers
        login,     // Pass the new login function
        logout,    // Pass the new logout function
        loadingHandle,
      }}
    >
      {/* This is critical: Don't render the rest of your app 
        until the auth check is complete. This prevents
        flashing/redirecting to /login before the user is verified.
      */}
      {isChecked ? children : null }
    </AuthContext.Provider>
  );
};